@if (shouldShowNotLoggedInInformation()) {
    <div class="flex items-center justify-center gap-1 bg-malou-pink--light p-3">
        <div class="flex items-center gap-1">
            <mat-icon class="text-malou-state-error" [svgIcon]="SvgIcon.WARNING"></mat-icon>
            <p class="malou-text-12--bold text-malou-text-title md:leading-none">{{ 'banner.connection.text' | translate }},</p>
        </div>
        <button class="malou-text-12--bold text-malou-pink" mat-button (click)="redirectToLogin()">
            {{ 'banner.connection.button' | translate }}
        </button>
    </div>
}
